enum DashboardExpandableWidgets {
    CALENDAR = "calendar",
    TODO = "todo",
}

export default DashboardExpandableWidgets;
